import React, { useEffect, useState } from "react";

const AddEditView = ({
  visible,
  onClose,
  onSave,
  initialData = null,
  mode = "add",
}) => {
  const defaults = {
    name: "",
    email: "",
    role: "admin",
    is_portal: true,
    phone: "",
    password: "",
    password_confirmation: "",
  };
  const [form, setForm] = useState(defaults);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (initialData) {
      setForm({
        name: initialData.name || "",
        email: initialData.email || "",
        role: initialData.role || "admin",
        is_portal: !!initialData.is_portal,
        phone: initialData.phone || "",
      });
    } else {
      setForm(defaults);
    }
  }, [initialData, visible]);

  if (!visible) return null;

  return (
    <div className="modal" role="dialog" aria-modal="true">
      <div className="modal-overlay" onClick={onClose} />
      <div className="modal-content">
        <h3>
          {mode === "add"
            ? "Add user"
            : mode === "edit"
            ? "Edit user"
            : "View user"}
        </h3>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            if (!form.name || !form.email) return;
            const newUser = {
              name: form.name,
              email: form.email,
              role: form.role,
              is_portal: !!form.is_portal,
              phone: form.phone || null,
            };

            if (onSave) {
              // support async onSave that returns a promise
              try {
                const result = onSave(newUser);
                if (result && typeof result.then === "function") await result;
              } catch (err) {
                // swallow here; parent can handle and show messages
                console.error("onSave error:", err);
              }
            }
          }}
        >
          <div className="form-grid">
            <div className="form-row">
              <label className="form-label">Name</label>
              <input
                className="form-input"
                placeholder="Name"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                disabled={mode === "view"}
              />
            </div>
            <div className="form-row">
              <label className="form-label">Email</label>
              <input
                className="form-input"
                placeholder="Email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                disabled={mode === "view"}
              />
            </div>
            <div className="form-row">
              <label className="form-label">Role</label>
              <select
                className="form-input"
                value={form.role}
                onChange={(e) => {
                  const role = e.target.value;
                  // auto-toggle portal flag: admin => true, user => false
                  setForm({ ...form, role, is_portal: role === "admin" });
                }}
                disabled={mode === "view"}
              >
                <option value="admin">admin</option>
                <option value="user">user</option>
              </select>
            </div>
            <div className="form-row">
              <label className="form-label">Phone</label>
              <input
                className="form-input"
                placeholder="Phone"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                disabled={mode === "view"}
              />
            </div>
          </div>

          <div
            style={{
              display: "flex",
              gap: 8,
              justifyContent: "flex-end",
              marginTop: 14,
            }}
          >
            <button type="button" className="btn-secondary" onClick={onClose}>
              Cancel
            </button>
            {mode !== "view" && (
              <button type="submit" className="btn-primary">
                Save
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEditView;
